import { omit } from "lodash-unified";
import { useUser } from "../hooks/use-user.mjs";
const { setUserInfo, setToken, getToken } = useUser();
const handleTokenGuard = async (to, _, next) => {
  if (to.name === "Login" || to.path === "/" || to.path === "/login")
    next();
  else {
    if (to.query.token) {
      if (!getToken()) {
        setToken(to.query.token);
        await setUserInfo();
      }
      next(Object.assign(to, { query: omit(to.query, ["token"]) }));
    } else {
      next();
    }
  }
};
export { handleTokenGuard };
